module.exports = __webpack_public_path__ + "static/media/integracao.63f5c487.svg";